import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const InvitationContext = createContext(null);

export const useInvitation = () => useContext(InvitationContext);

export const InvitationProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const eventKey = window.location.pathname.startsWith("/walimah") ? "walimah" : "main";
  const eventBase = eventKey === "walimah" ? "/walimah" : "";

  useEffect(() => {
    axios
      .get(`${API}/invitation?key=${eventKey}`)
      .then((res) => setData(res.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [eventKey]);

  const updateField = (path, value) => {
    setData((prev) => {
      if (path.includes(".")) {
        const [group, key] = path.split(".");
        return { ...prev, [group]: { ...prev[group], [key]: value } };
      }
      return { ...prev, [path]: value };
    });
  };

  const addItem = (field, item) =>
    setData((p) => ({ ...p, [field]: [...(p[field] || []), item] }));

  const removeItem = (field, id) =>
    setData((p) => ({ ...p, [field]: (p[field] || []).filter((i) => i.id !== id) }));

  const updateItem = (field, id, key, value) =>
    setData((p) => ({
      ...p,
      [field]: (p[field] || []).map((i) => (i.id === id ? { ...i, [key]: value } : i)),
    }));

  const moveItem = (field, id, dir) =>
    setData((p) => {
      const arr = [...(p[field] || [])];
      const idx = arr.findIndex((i) => i.id === id);
      const j = idx + dir;
      if (idx < 0 || j < 0 || j >= arr.length) return p;
      [arr[idx], arr[j]] = [arr[j], arr[idx]];
      return { ...p, [field]: arr };
    });

  const save = async (override) => {
    const payload = override || data;
    if (!payload) return;
    setSaving(true);
    try {
      const res = await axios.put(`${API}/invitation?key=${eventKey}`, payload);
      setData(res.data);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    } finally {
      setSaving(false);
    }
  };

  const reset = async () => {
    const res = await axios.post(`${API}/invitation/reset?key=${eventKey}`);
    setData(res.data);
  };

  const listBackups = async () => {
    const res = await axios.get(`${API}/invitation/backups?key=${eventKey}`);
    return res.data;
  };

  const restoreBackup = async (backupId) => {
    const res = await axios.post(`${API}/invitation/restore/${backupId}`);
    setData(res.data);
    return true;
  };

  return (
    <InvitationContext.Provider
      value={{ data, setData, updateField, addItem, removeItem, updateItem, moveItem, save, reset, listBackups, restoreBackup, loading, saving, API, eventKey, eventBase }}
    >
      {children}
    </InvitationContext.Provider>
  );
};
